import React from "react";

import { useNetworkInformation } from "@/modules/shared/hooks/use-network-information";

import type { ParamsMessageProps } from "@/modules/shared/atoms/params-message/types";

import "./params-message.scss";

const ParamsMessage: React.FC<ParamsMessageProps> = ({ userData }) => {
  const connection = useNetworkInformation();

  if (import.meta.env.VITE_API_BASE_URL !== "https://api.regt-bot.rs-test.ru") {
    console.log(userData);

    return null;
  }

  return (
    <div className="params-message">
      {`Params = From: ${userData.from} 
        || RegistrationType: ${userData.registrationType} 
        || Token: ${userData.token} 
        || ReferralCode: ${userData.referralCode} 
        || Connect: ${connection?.downlink}mb/s`}
    </div>
  );
};

export { ParamsMessage };
